import React, { useState } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import TopBarWrapper from '../TopBarWrapper/TopBarWrapper'
import Playlist from '../Playlist/Playlist';
import Resource from '../Resource/Resource';
import Link from "../Link/Link";
import Profile from '../Profile/Profile'
import FAQ from '../FAQ/FAQ';
import Search from '../Search/Search'; // TODO
import { connect } from 'react-redux'
import isElectron from 'is-electron'
import styled from 'styled-components'
import AvailableOfflineSection from "../Profile/Components/AvailableOfflineSection/AvailableOfflineSection";
import { OfflineColor, White } from "../../Constants/ColorChart";
import OfflinePlaylist from "../OfflinePlaylist/OfflinePlaylist";
import OfflineResource from "../OfflineResource/OfflineResource";

/*
 *  @Description:   Component that renders the content.
 */

const StyledOffline = styled.div`
    position: fixed;
    top: 56px;
    background: ${ OfflineColor };
    width: 100%;
    color: ${ White };
    text-align: center;
    z-index: 1;
`

const AvailableOfflineWrapper = styled.div`
    position: relative;
    top: 75px;
    & > div {
        margin: unset;
        width: 100%;
    }
`

const ContentContainer = ( props ) => {
    const { isNetworkAvailable /*, isServerReachable*/ } = props;
    const canConnect = isNetworkAvailable //&& isServerReachable;

    const [ title, setTitle ] = useState( null );

    const changeTitle = ( newTitle ) => {
        setTitle( newTitle );
    }

    return (
        <div className="contentContainer">
            { !canConnect && <StyledOffline>OFFLINE</StyledOffline> }
            <TopBarWrapper title={ title }/>
                <Switch>
                <Route path='/profile/:id' render={ () => <Profile changeTitle={ changeTitle }/> }/>
                <Route exact path='/faq' render={ () => <FAQ changeTitle={ changeTitle }/> }/>

                <Route exact path='/offlinePlaylist/:id'
                       render={ () => <OfflinePlaylist changeTitle={ changeTitle }/> }/>
                <Route exact path='/offlineResource/:id'
                       render={ () => <OfflineResource changeTitle={ changeTitle }/> }/>

                { (!isElectron() || canConnect) &&
                <>
                    <Route exact path='/search/:searchString' render={ () => <Search/> }/>
                    <Route exact path='/playlist/:id'
                           render={ () => <Playlist changeTitle={ changeTitle }/> }/>
                    <Route exact path='/resource/:id'
                           render={ () => <Resource changeTitle={ changeTitle }/> }/>
                    <Route exact path='/link/:id/:index?'
                           render={ () => <Link changeTitle={ changeTitle }/> }/>
                    <Route exact path="/new_user"
                           render={ () => <Redirect to="/"/> }/>
                    <Route path={ "/password_recovery/:hash?/:uid?/:timestamp?" }
                           render={ () => <Redirect to="/"/> }/>
                </>
                }

                { isElectron() && canConnect !== null && !canConnect &&
                <>
                    <Route exact path='/playlist/:id'
                           render={ () => <AvailableOfflineWrapper className={ "container" }>
                               <AvailableOfflineSection changeTitle={ changeTitle }/>
                           </AvailableOfflineWrapper> }/>
                    <Route exact path='/resource/:id'
                           render={ () => <AvailableOfflineWrapper className={ "container" }>
                               <AvailableOfflineSection changeTitle={ changeTitle }/>
                           </AvailableOfflineWrapper> }/>
                    <Route path='/search/:searchString?'
                           render={ () => <AvailableOfflineWrapper className={ "container" }>
                               <AvailableOfflineSection changeTitle={ changeTitle }/>
                           </AvailableOfflineWrapper> }/>
                </>
                }
            </Switch>
        </div>
    )

}

const mapStateToProps = ( state ) => ({
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable
})

export default withRouter( connect( mapStateToProps, {} )( ContentContainer ) );